import { render, staticRenderFns } from "./answer-data.vue?vue&type=template&id=e991cc2e&scoped=true&"
import script from "./answer-data.vue?vue&type=script&lang=js&"
export * from "./answer-data.vue?vue&type=script&lang=js&"
import style0 from "./answer-data.vue?vue&type=style&index=0&id=e991cc2e&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e991cc2e",
  null
  
)

export default component.exports